/* eslint-disable no-unused-vars */
/* eslint-disable no-return-assign */
/* eslint-disable react/destructuring-assignment */
import React, { Component, Fragment } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import Hotel from './hotel';
import './salida.css';
import featureAvailability from '../../commons/featureAvailability';
import common from '../../commons/commons';

class Salida extends Component {
  constructor(props) {
    super(props);
    this.armarHoteles = this.armarHoteles.bind(this);
  }

  obtenerReferencia() {
    if (this.props.datos.referencia.interna) {
      if (this.props.datos.referencia.interna !== '') return this.props.datos.referencia.interna;
    }

    return this.props.datos.referencia.externa;
  }

  armarHoteles() {
    const listaHoteles = [];
    if (this.props.hoteles && this.props.hoteles.length > 0) {
      for (let i = 0; i < this.props.hoteles.length; i++) {
        listaHoteles.push(
          <li className='item-hotel' key={i}>
            <Hotel datos={this.props.hoteles[i]} proveedorId={this.props.proveedorId} />
          </li>,
        );
      }
    }
    return (
      <div className='dropdown salida-hoteles'>
        <span
          role='button'
          className='dropdown-toggle'
          id='drop-salida-hoteles'
          data-toggle='dropdown'
          aria-haspopup='true'
          aria-expanded='true'
        >
          <i className='fa fa fa-chevron-down' />
          {' '}
          Ver hoteles
        </span>
        <ul className='dropdown-menu' aria-labelledby='drop-salida-hoteles'>
          {listaHoteles}
        </ul>
      </div>
    );
  }

  transporteElemento() {
    const { datos } = this.props;
    let img = '';
    let nombreTransporte = '';

    //Valida proveedor Allseasons
    if (datos.transporte.transporteAereo !== null) {
      img = datos.transporte.transporteAereo.imagen === null || datos.transporte.transporteAereo.imagen === undefined
        ? ''
        : datos.transporte.transporteAereo.imagen;
      nombreTransporte = datos.transporte.transporteAereo.nombreLineaAerea === null || datos.transporte.transporteAereo.nombreLineaAerea === undefined
        ? ''
        : datos.transporte.transporteAereo.nombreLineaAerea;
    }

    const transporte = {
      img,
      nombreTransporte,
    };

    return this.armarInfoAerolinea(transporte);
  }

  armarInfoAerolinea = (transporte) => {
    const elemento = '';

    if (transporte.img.length > 3) {
      return (<img src={transporte.img} title={transporte.nombreTransporte} alt={transporte.nombreTransporte} className='img-responsive' height='20px' width='85px' />);
    }
    if (transporte.nombreTransporte.length > 1) {
      return (
        <span>
          Viajando por:
          <span className='nombre-agencia'>
            {' '}
            {transporte.nombreTransporte}
          </span>
        </span>
      );
    }
    return elemento;
  }

  getDate = (value, format, returnedText = 'NOP ', appendedText = '') => {
    if (
      value === null
      || value === '0001-01-01T00:00:00'
      || value === undefined
    ) {
      return returnedText;
    }
    if (format.toUpperCase().includes('H') && value.includes('00:00:00')) {
      return returnedText;
    }
    return `${moment(value).format(format)} ${appendedText}`;
  }

  render() {
    const { application, packagesDestination, salidas, indice, datos } = this.props;
    let countryName = '';
    if (packagesDestination !== null) {
      return countryName = packagesDestination.country_name;
    }
    // checking if country tax is apply in application country ID
    const countryTaxApply = featureAvailability.countryFeatureChecker(application.paisId, countryName, 'countryTax');
    // checking if price include the new country tax
    const countryTaxIsIncluded = common.checkCountryTax(salidas[indice].precios.impuestoPais);

    const titleUrl = this.props.title.toLowerCase()
      .replace(/[-]/g, ' ')
      .replace(/[%]/g, ' ')
      .replace(/\s/g, '-')
      .replace(/[-][-][-]/g, '-')
      .replace(/[-][-]/g, '-')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/amp;/g, '');

    const ngrupo = this.props.salidas[indice].hoteles[0] !== undefined ? this.props.salidas[indice].hoteles[0].nroGrupo : null;
    const idOrigen = this.props.salidas[indice].origenIata ? this.props.salidas[indice].origenIata : '';
    const origen = this.props.salidas[indice].origen !== null ? this.props.salidas[indice].origen : '';
    const nroComb = this.props.nroComb !== undefined ? this.props.nroComb : null;

    const redirectTag = window.location.href.indexOf('detalle') === -1
      ? `${process.env.RAZZLE_URL_PATH
      }/viajes/${window.location.pathname.split('/')[4]}/${titleUrl
      }?t=${this.obtenerReferencia()
      }&h=${this.props.distribucion
      }&p=${this.props.proveedorId
      }&s=${moment(datos.fechaSalida).format('YYYY-MM-DD')
      }&i=${this.props.idProducto
      }&m=${datos.precios.moneda
      }&d=${datos.destinoIata
      }&ngrupo=${ngrupo
      }&nroComb=${nroComb
      }&origen=${idOrigen}`

      : `${process.env.RAZZLE_URL_PATH
      }/viajes/${titleUrl
      }?t=${this.obtenerReferencia()
      }&h=${this.props.distribucion
      }&p=${this.props.proveedorId
      }&s=${moment(datos.fechaSalida).format('YYYY-MM-DD')
      }&i=${datos.idProducto
      }&m=${datos.precios.moneda
      }&d=${datos.idDestino
      }&ngrupo=${ngrupo
      }&nroComb=${nroComb
      }&origen=${idOrigen}`;

    let { cupos } = datos;
    cupos = cupos !== 0 ? `${cupos} lugares` : 'Consultar Disponibilidad';

    let salida;
    if (this.props.proveedorId === 3) {
      if (datos.uniqueOperationDate) {
        salida = moment(datos.operationDate).format('MM/DD/YYYY');
      } else {
        const fechaDesde = moment(datos.fechaSalida).format('MM/DD/YYYY');
        const fechaHasta = moment(datos.fechaLlegada).format('MM/DD/YYYY');
        salida = {
          fechaDesde,
          fechaHasta,
        };
      }
    } else {
      salida = moment(datos.fechaSalida).format('MM/DD/YYYY');
    }

    const { precios } = datos;
    const currencyDefault = application.currency.code;
    const precio = this.props.formatearPrecio(
      currencyDefault === 'USD' && precios.precioNetoDolares != null
        ? precios.precioNetoDolares
        : precios.precioNeto,
      currencyDefault === 'USD' && precios.impuestosDolares != null
        ? precios.impuestosDolares
        : precios.impuestos,
      currencyDefault === 'USD'
        ? 0
        : precios.impuestoPais,
      currencyDefault === 'USD' && precios.ivaDolares != null
        ? precios.ivaDolares
        : precios.iva,
      this.props.cant_pasajeros,
    );

    const mobile = window.innerWidth <= 768;
    const formatoDia = mobile ? 'ddd D' : 'dddd D';
    const formatoMes = mobile ? 'MMM' : 'MMMM';
    const fechaDeSalida = salida.fechaDesde
      ? `${this.getDate(salida.fechaDesde, formatoDia)} de ${this.getDate(salida.fechaDesde, formatoMes)}`
      : `${this.getDate(salida, formatoDia)} de ${this.getDate(salida, formatoMes)}`;

    return (
      <a href={redirectTag} target='_blank' rel='noopener noreferrer'>
        <div className='sub-panel'>
          <div className='fecha-precio'>
            <div className=''>{fechaDeSalida}</div>
            <div className='contenedor-precio'>
              <span className='moneda'>
                {currencyDefault === 'USD' && precios.precioNetoDolares != null
                  ? 'USD ' : 'ARS '}
              </span>
              { precio }
            </div>
          </div>
          <div className='hotel-transporte-btn-detalle'>
            <div className='contenedor-hoteles hidden-xs'>{this.armarHoteles()}</div>
            {/*<div className="contenedor-transporte-empresa hidden-xs">{this.transporteElemento()}</div>*/}
            {/*<div className="cupos">*/}
            {/*{datos.cupos} cupos*/}
            {/*</div>*/}
            {currencyDefault === 'USD' && countryTaxIsIncluded
              ? (
                <>
                  <span className='dib included'>impuesto pais no incluido</span>
                </>
              )
              : countryTaxApply && (
                <span className='country-tax'>
                  { countryTaxIsIncluded
                    ? (
                      <>
                        <span className='dib included'>Incluye </span>
                        <span className='dib included'>30% IMPUESTO PAIS</span>
                      </>
                    )
                    : (
                      <>
                        <span className='dib not-included'>No incluye </span>
                        <span className='dib not-included'>30% IMPUESTO PAIS</span>
                      </>
                    )}
                </span>
              )}
            <span
              role='button'
              className='button-salida-detalle color-dinamico'
              target='_blank'
              rel='noopener noreferrer'
            >
              Ver detalle
            </span>
          </div>
        </div>
      </a>
    );
  }
}
const mapStateToProps = (state) => ({
  application: state.applicationState,
  packagesDestination: state.packages.ciudadDestino,
});

export default connect(mapStateToProps, null)(Salida);
